import Collection from "../../data-structures/collection"
import StarredItem from "./starred-item"
import {SESSION_STARRED_CHANGED} from "../../gd/bus/bus-event-type"
import ProjectSession from "../project/project-session"

// const debug = "StarredItemsCollection"
const debug = false

export default class StarredItemsCollection extends Collection<StarredItem>{

    constructor(models:StarredItem[]) {
        super(models)
    }

    static initFromJson(data: any): StarredItemsCollection{

        const models: StarredItem[] = []

        _.map(data, (record: JSONObject)=>{
            models.push(new StarredItem(record))
        })

        return new StarredItemsCollection(models)
    }

    add(model: StarredItem | null) {
        super.add(model)

        if (model) {
            debug && console.log(debug, 'add trigger event', model)
            gd.bus.triggerEventDebounced(SESSION_STARRED_CHANGED)
        }
    }

    removeItem(starredItem?: StarredItem | null): StarredItem[] {
        if (!starredItem) return []

        const removed = _.remove(this.models, model=>{
            let res
            if (starredItem.taskId)     res = model.taskId === starredItem.taskId
            if (starredItem.projectId)  res = model.projectId === starredItem.projectId
            return res
        })

        _.map(removed, removedItem=>{
            delete this.byId[removedItem.id]
        })

        if (!_.isEmpty(removed)) {
            debug && console.log(debug, 'remove trigger event', removed)
            gd.bus.triggerEvent(SESSION_STARRED_CHANGED)
        }

        return removed
    }

    getTaskStarredItem(taskId: ID) {
        return _.find(this.models, i=>i.taskId === taskId)
    }

    getProjectStarredItem(projectId: ID):StarredItem|undefined {

        // const result : StarredItem[] = []
        //
        // _.map(this.models, (i:StarredItem)=>{
        //     if (i.projectId === projectId) {
        //         result.push(i)
        //     }
        // })
        //
        // return result

        return _.find(this.models, (i:StarredItem)=>{
            return i.projectId === projectId
        })
    }

    getProjectsIds():ID[] {

        return _(this.models)
            // @ts-ignore
            .filter((starredItem: StarredItem)=>{
                return !!starredItem.projectId && gd.session.projects.get(starredItem.projectId)
            })
            .map((starredItem: StarredItem)=>starredItem.projectId)
            .value()
    }

    get starredProjects():ProjectSession[] {
        const starredProjects: ProjectSession[] = []

        _.map(this.getProjectsIds(), (projectId:ID)=>{
            const project = gd.session.projects.get(projectId);

            if (project && !project.isTag) {
                return starredProjects.push(project)
            }
        });
        return starredProjects
    }
}
